import { useEffect, useState } from "react";
import { getDestinations } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import PageHero from "../components/layout/PageHero";
import CTASection from "../components/CTASection";
import { DestinationCard } from "../components/Cards";
import { CardSkeletons, ErrorState } from "./Home";
import { Reveal } from "../components/motion/Reveal";

export default function Destinations() {
  useSEO(
    "Study Destinations — Suvera Academy",
    "Explore study-abroad destinations with Suvera Academy: USA, UK, Canada, Australia, New Zealand, Germany, Singapore, Malaysia and Mauritius."
  );
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    getDestinations()
      .then(setDestinations)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="destinations-page">
      <PageHero
        eyebrow="Study Destinations"
        title="Where Will Your Journey Take You?"
        description="Nine destinations, each with distinct academic strengths, cultures and career opportunities. Explore them all — or let an advisor help you compare."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Destinations" }]}
        testid="destinations-hero"
      />
      <section className="mx-auto max-w-[1440px] px-4 py-16 sm:px-6 lg:px-10 lg:py-24">
        {loading ? (
          <CardSkeletons count={6} />
        ) : error ? (
          <ErrorState message="Destinations could not be loaded. Please refresh the page." />
        ) : (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3" data-testid="destinations-grid">
            {destinations.map((d, i) => (
              <Reveal key={d.slug} delay={(i % 3) * 0.08} className={i === 0 ? "md:col-span-2" : ""}>
                <DestinationCard d={d} large={i === 0} />
              </Reveal>
            ))}
          </div>
        )}
      </section>
      <CTASection />
    </main>
  );
}
